import { render, staticRenderFns } from "./MessagesNetwork.vue?vue&type=template&id=69c0c1c2&"
import script from "./MessagesNetwork.vue?vue&type=script&lang=js&"
export * from "./MessagesNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports